export default __webpack_public_path__ + "static/media/people9.4e73f724.jpeg";